export class TimeOffInfoEntity {
  public id!: string;
  public type!: string;
  public startDate!: string;
  public endDate!: string;
  public durationDays!: number;
  public notes!: string;
}
